import type {TypedValue} from '../../../../../services/rest'
import {stringifyId} from '../../../../../types'
import type {BuildId, BuildTypeId} from '../../../../../types'
import isVisualTest from '../../../../../utils/isVisualTest'
import {resolveRelative} from '../../../../../utils/url'

const visualTest = isVisualTest()
export const getSrcLink = (
  link = '',
  buildTypeId: BuildTypeId | null | undefined,
  buildId: BuildId | null | undefined,
): string =>
  visualTest
    ? `${link}`
    : resolveRelative(
        `/repository/download/${stringifyId(buildTypeId)}/${stringifyId(buildId)}:id/${encodeURI(
          link,
        ).replace(/#/g, encodeURIComponent('#'))}`,
      )
export const getFileName = ({value = ''}: TypedValue): string => {
  if (!value) {
    return ''
  }

  const path = value.split('/')
  return path[path.length - 1] ?? 'Unknown file name'
}
export const getName = (metadata: TypedValue) =>
  metadata?.name?.includes('teamcity.auto.name:') ? undefined : metadata.name
